import React from 'react'
import pluginConfig from '../lib/cookieConsentConfig'
import 'vanilla-cookieconsent'
import 'vanilla-cookieconsent/dist/cookieconsent.css'

/**
 * CookieConsentComp initializes and displays the cookie consent banner using the `vanilla-cookieconsent` library.
 *
 * This component runs a side effect to initialize the cookie consent plugin on mount. It uses a configuration
 * imported from `cookieConsentConfig`. The cookie consent banner is displayed only if it hasn't already been
 * initialized on the page.
 *
 * @module common/CookieConsentComp
 * @description CookieConsentComp initializes and displays the cookie consent banner using the `vanilla-cookieconsent` library.
 *
 * This component runs a side effect to initialize the cookie consent plugin on mount. It uses a configuration
 * imported from `cookieConsentConfig`. The cookie consent banner is displayed only if it hasn't already been
 * initialized on the page.
 *
 * @example
 * return (
 *   <CookieConsentComp />
 * );
 *
 * @returns {null} This component does not render anything to the DOM.
 */
export const CookieConsentComp = () => {
  React.useEffect(() => {
    // Initialize cookie consent if it's not already present on the page
    if (!document.getElementById('cc--main')) {
      window.CC = window.initCookieConsent()
      window.CC.run(pluginConfig)
    }
  }, [])

  return null
}
